var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":"","color":"error","height":"30","depressed":"","rounded":""},on:{"click":function($event){return _vm.desconectar()}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }